import { UpsertOrganisationSettingsRequest } from '@/apiClient/api';
import { usePrivate } from '@/components/private';
import { enqueueSnackbar } from '@/providers';
import useSWRMutation from 'swr/mutation';

export const getPostOrgSettingsCachedKey = () => [
  '/api/OrganisationSetting/Bulk',
];

export const usePostOrgSettings = () => {
  const { selectedOrganisationId, organisationSettingApi } = usePrivate();

  const path =
    selectedOrganisationId && organisationSettingApi
      ? getPostOrgSettingsCachedKey()
      : null;

  const { data, trigger, isMutating } = useSWRMutation(
    path,
    (key, { arg }: { arg: UpsertOrganisationSettingsRequest[] }) =>
      organisationSettingApi?.apiOrganisationSettingBulkPost(arg),
    {
      onSuccess: () => {
        enqueueSnackbar('Organisation settings has been updated successfully', {
          variant: 'success',
        });
      },
      onError(error) {
        console.log(
          '[BREEDLOGIC] <usePostOrgSettings> error update custom form.',
          error,
        );
      },
    },
  );

  return {
    data,
    trigger,
    isLoading: isMutating,
  };
};
